import React, { Component } from "react";
import createStyles from "@material-ui/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MyPATDialog from "../../../../common/MyPATDialog";
import Challenge from "../../../types/ChallengeQuestion";
import { capitalize } from "lodash";
import { dateService } from "../../../../common";
import { Chip } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    primaryBtn: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "19px",
      height: "44px",
      color: "#fff",
      backgroundColor: "#1D7DEA",
      padding: "8px 30px",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#1D7DEA",
      },
    },
    outlineBtn: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "19px",
      height: "44px",
      color: "#1D7DEA",
      backgroundColor: "transparent",
      padding: "8px 30px",
      textTransform: "capitalize",
      border: "none",
      "&:hover": {
        border: "none",
        backgroundColor: "transparent",
      },
    },
    btnOutline: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "19px",
      height: "44px",
      color: "#1D7DEA",
      backgroundColor: "transparent",
      padding: "8px 30px!important",
      textTransform: "capitalize",
      border: "solid 1px #1d7dea",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    userHeading: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "25px",
      color: "#333",
      margin: "0 0 12px",
    },
    normalTxt: {
      fontSize: "14px",
      fontWeight: "normal",
      lineHeight: "150%",
      color: "#333",
    },
    timeLog: {
      fontSize: "18px",
      fontWeight: "normal",
      lineHeight: "25px",
      color: "#666",
    },
    normalHeading: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "19px",
      color: "#333",
      margin: "0 0 8px",
    },
    imagePanel: {
      marginTop: "15px",
      "& img": {
        maxWidth: "100%",
      },
    },
    editImg: {
      margin: "15px 0 15px 0",
    },
    marginLR: {
      margin: "0 60px",
    },
    chip: {
      border: "1px solid #1D7DEA",
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "16px",
      padding: "6px 24px",
      margin: "0px 12px 12px 0px",
      background: "transparent",
      color: "#1d7dea",
      "&:hover": {
        color: "#1d7dea",
      },
      "&:focus": {
        backgroundColor: "tranparent",
        color: "#1d7dea",
      },
    },
    chipInactive: {
      backgroundColor: "transparent!important",
      color: "#999!important",
      borderColor: "#E6E6E6",
      "& span": {
        padding: "0px",
      },
    },
    chipActive: {
      borderColor: "#1d7dea",
      backgroundColor: "transparent!important",
      color: "#1d7dea",
      "& span": {
        padding: "0px",
      },
    },
    dialogHeading: {
      fontSize: "16px",
      lineHeight: "22px",
      color: "#666",
      textAlign: "left",
      margin: "0px 0 12px 0",
      display: "block",
    },
    minHeight: {
      minHeight: "325px",
    },
    qId: {
      fontSize: 16,
      fontWeight: 600,
      color: "#333",
      margin: "0px 0 15px 0",
      display: "block",
    },
    description: {
      fontSize: 16,
      fontWeight: 400,
      color: "#999",
      marginBottom: "30px",
      marginTop: "18px",
      wordBreak: "break-all",
      "& p": {
        margin: 0,
      },
    },
    attachmentHeading: {
      fontSize: 16,
      fontWeight: 400,
      color: "#666",
      marginBottom: "12px",
    },
    attachted_img: {
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
    },
    attachment_type: {
      marginRight: 15,
      textDecoration: "none",
      marginBottom: 15,
      display: "inline-block",
      "& p": {
        fontSize: 10,
        fontWeight: 500,
        color: "#999",
        marginTop: 3,
        "& span": {
          minWidth: 6,
          maxWidth: 97,
          display: "inline-block",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          verticalAlign: "bottom",
        },
      },
    },
    "a":{
      textDecoration: "none"
    },
    img_container: {
      position: "relative",
      border: "1px solid #D1D1D1",
      width: 120,
      height: 120,
      borderRadius: 8,
      marginRight: 15,
      marginBottom: 35,
      textDecoration: "none",
      "& img": {
        width: "100%",
        height: "100%",
        borderRadius: 8,
      },
      "& a":{
        textDecoration: "none"
      },
      "& p": {
        fontSize: 10,
        fontWeight: 500,
        color: "#999",
        marginTop: 3,
        "& span": {
          minWidth: 6,
          maxWidth: 97,
          display: "inline-block",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          verticalAlign: "bottom",
        },
      },
    },
    viewMore: {
      position: "absolute",
      width: 120,
      height: 120,
      background: "rgba(0, 0, 0, 0.7)",
      border: "1px solid #D1D1D1",
      borderRadius: 8,
      fontSize: 16,
      fontWeight: 700,
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      top: 0,
    },
    toolBox: {
      position: "sticky",
      top: 0,
      zIndex: 99,
      background: "#FBFBFB",
      borderBottom: "1px solid #eee",
      marginTop: "-15px",
      right: 0,
      marginLeft: "auto",
      boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.12)",
      "& .arrow": {
        padding: "0px 3px 2px 2px",
        borderRadius: "50%",
        margin: "0px 4px",
        color: "#fff",
        cursor: "pointer",
        "&:hover": {
          background: "rgb(29 125 234)",
        },
      },
      "& .closeButton": {
        color: "#1d7dea",
        cursor: "pointer",
        verticleAlign: "middle",
        "& svg": {
          marginBottom: 2,
        },
      },
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "100%",
      bottom: 0,
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "26px",
      padding: "15px 24px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      // display: 'grid',
      gridTemplateColumns: "92% 8%",
      alignItems: "center",
      "& button": {
        padding: "10px 15px",
        // maxWidth: 140,
        // width: "100%",
      },
    },
    paddingBot50: {
      paddingBottom: 210,
    },
    displayFlex: {
      display: "flex",
    },
    actionContainer: {
      alignSelf: "flex-end",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      "& > *": {
        marginLeft: theme.spacing.unit * 2,
        minWidth: "58px",
      },
      "& img": {
        marginRight: 3,
      },
    },
    shareButton: {
      background: theme.palette.common.white,
    },
    blue: {
      border: "solid 1px #1D7DEA",
      boxSizing: "border-box",
      color: "#1D7DEA",
      fontWeight: 600,
    },
    copyButton: {
      background: theme.palette.common.white,
      "& .disabled": {
        opacity: 0.3,
      },
    },
    dialogContentbox: {
      maxHeight: 'calc(100vh - 270px)',
    }
  });

enum IssueArea {
  AMBIGIOUS_CONTENT = "Ambiguous Content",
  INCORRECT_OPTION_OR_ANSWER = "Incorrect Options/Answer",
  INCORRECT_SOLUTION = "Incorrect Solution",
  INCORRECT_CONCEPT = "Incorrect concept",
  INCORRECT_DIFFICULTY_OR_SKILL = "Incorrect Difficulty/Skill",
  INCORRECT_QUESTION = "Incorrect Question",
}
interface viewChallengeProps {
  classes: any;
  open: boolean;
  data: any;
  onClose: any;
  contentId: string;
  onDismiss: (challengeId: string) => void;
  onAccept: (challengeId: string) => void;
}

interface viewChallengeState {
  showMoreAttachments: boolean;
  isQuestionChallengefromCms: boolean;
}

class ViewChallengePopup extends Component<
  viewChallengeProps,
  viewChallengeState
> {
  constructor(props: viewChallengeProps) {
    super(props);
    this.state = {
      showMoreAttachments: false,
      isQuestionChallengefromCms: !this.props.data.metaData,
    };
  }

  handleAccept = (e: any, _id: any) => {
    this.props.onAccept(_id);
    this.props.onClose();
  };

  handleDismiss = (e: any, _id: any) => {
    this.props.onDismiss(_id);
    this.props.onClose();
  };

  openAttachment = (e: any, attachmentUrl: any) => {
    window.open(attachmentUrl.url);
    return false;
  };

  getAttachmentsCount = () => {
    return `${this.props.data.attachments.length} File${
      this.props.data.attachments.length > 1 ? "s" : ""
    } Attached`;
  };

  showMoreImgs = () => {
    this.setState({ showMoreAttachments: true });
  };

  getFileNameFromUrl = (url: string) => {

    let fileName = [];
    const arr = url.split("/");
    fileName = arr[arr.length - 1].split(".");
    if (this.state.isQuestionChallengefromCms){
      return fileName[0].substring(36);
    }
    return fileName[0];
  };

  getFileExtension = (url: string) => {
    const arr = url.split(".");
    return arr[arr.length - 1];
  };

  getFileTypeFromUrl = (url : string) => {
    const last3 = url.slice(-3);
    const last4 = url.slice(-4);

    if (last3 === 'pdf' || last3 === 'doc') {
      return last3;
    } else if (last4 === 'docx') {
      return 'doc';
    } else {
      return 'image';
    }
  }

  updateChallengeAttachments = () => {
    // if no url option added then need to manipulate attachment array
    if (this.state.isQuestionChallengefromCms && this.props.data.attachments.length && !this.props.data.attachments[0].url){
      for (let i = 0; i < this.props.data.attachments.length; i++) {
        const helperObj : any = {};
        helperObj.url = this.props.data.attachments[i];
        helperObj.type = this.getFileTypeFromUrl(this.props.data.attachments[i]);
        this.props.data.attachments[i] = helperObj;
      }
    }
  }

  render() {
    const { classes, open, data, onClose, onDismiss, onAccept } = this.props;
    const {
      reviewer: { name },
      issueArea,
      issueDescription,
      createdAt,
      attachments,
      status,
      _id,
    } = data;
    this.updateChallengeAttachments();

    return (
      <MyPATDialog
        dialogOpen={open}
        dialogHasActions={true}
        dialogHeading={"View Challenge"}
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        onDialogClose={onClose}
        isCustomBackground={false}
        isborderDialogAction={false}
        otherDialogProps={{
          fullWidth: false,
          maxWidth: "sm",
        }}
        customDialogActions={
          <>
            <Grid container justify="space-between" alignItems="center">
              <Typography className={classes.fileSize}>
                {this.getAttachmentsCount()}
              </Typography>
              {status !== "open" && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.props.onClose()}
                >
                  Ok
                </Button>
              )}
              {status === "open" && (
                <>
                  <div>
                    <Button
                      autoFocus
                      className={classes.btnOutline}
                      variant="outlined"
                      color="primary"
                      onClick={(e) =>
                        this.handleDismiss(e, this.props.data._id)
                      }
                    >
                      Dismiss
                    </Button>
                    <Button
                      className={classes.primaryBtn}
                      autoFocus
                      color="primary"
                      onClick={(e) => this.handleAccept(e, this.props.data._id)}
                    >
                      Accept
                    </Button>
                  </div>
                </>
              )}
            </Grid>
          </>
        }
      >
        <Grid
          container
          direction="row"
          justify="flex-start"
          className={classes.dialogContentbox}
        >
          <Grid item xs={12}>
            <Typography className={classes.qId}>
              {this.props.contentId}
            </Typography>
            <Typography className={classes.dialogHeading}>
              Issue areas in the content:
            </Typography>
          </Grid>
          <div className={classes.root}>
            {Object.values(IssueArea).map((issueArea) => {
              const issueAreas = this.props.data.issueArea.split(",");
              issueAreas.forEach((issue: string) => {
                issue = issue.trim();
              });
              const isActive = issueAreas.includes(issueArea);

              return (
                <Chip
                  key={issueArea}
                  label={issueArea}
                  className={[
                    classes.chip,
                    isActive ? classes.chipActive : classes.chipInactive,
                  ].join(" ")}
                  color="primary"
                />
              );
            })}
          </div>
          <Typography
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: this.props.data.issueDescription,
            }}
          />
          <Grid item xs={12}>
            <Typography className={classes.attachmentHeading}>
              Attachments
            </Typography>
            <Grid className={classes.attachted_img}>
              {this.props.data.attachments.length > 4 &&
                !this.state.showMoreAttachments &&
                this.props.data.attachments.map(
                  (attachment: any, index: number) => {
                    if (index > 3) {
                      return;
                    }
                    if (attachment.type === "doc") {
                      return (
                        <>
                        <Grid style={{position: "relative"}}>
                          <a
                            href={attachment.url}
                            className={classes.attachment_type}
                          >
                            <img
                              src="/assets/svg/doc.svg"
                              alt={`attachment-${index}`}
                              key={index}
                            />
                            {index !== 3 && (
                              <Typography>
                                <span>
                                  {this.getFileNameFromUrl(attachment.url)}
                                </span>
                                .{this.getFileExtension(attachment.url)}
                              </Typography>
                            )}
                          </a>
                          {index === 3 && (
                            <span
                              className={classes.viewMore}
                              onClick={this.showMoreImgs}
                            >
                              More
                            </span>
                          )}
                          </Grid>
                        </>
                      );
                    } else if (attachment.type === "pdf") {
                      return (
                        <>
                        <Grid style={{position: "relative"}}>
                          <a
                            href={attachment.url}
                            className={classes.attachment_type}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/assets/svg/pdf.svg"
                              alt={`attachment-${index}`}
                              key={index}
                            />
                            {index !== 3 && (
                              <Typography>
                                <span>
                                  {this.getFileNameFromUrl(attachment.url)}
                                </span>
                                .{this.getFileExtension(attachment.url)}
                              </Typography>
                            )}
                          </a>
                          {index === 3 && (
                            <span
                              className={classes.viewMore}
                              onClick={this.showMoreImgs}
                            >
                              More
                            </span>
                          )}
                          </Grid>
                        </>
                      );
                    } else {
                      return (
                        <>
                          <Grid className={classes.img_container}>
                            <a
                              href={attachment.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={attachment.url}
                                alt={`attachment-${index}`}
                                key={index}
                              />
                              {index !== 3 && (
                              <Typography>
                                <span>
                                  {this.getFileNameFromUrl(attachment.url)}
                                </span>
                                .{this.getFileExtension(attachment.url)}
                              </Typography>
                            )}
                            </a>
                            {index === 3 && (
                              <span
                                className={classes.viewMore}
                                onClick={this.showMoreImgs}
                              >
                                More
                              </span>
                            )}
                          </Grid>
                        </>
                      );
                    }
                  }
                )}

              {(this.props.data.attachments.length < 5 ||
                this.state.showMoreAttachments) &&
                this.props.data.attachments.map(
                  (attachment: any, index: number) => {
                    if (attachment.type === "doc") {
                      return (
                        <>
                          <a
                            href={attachment.url}
                            className={classes.attachment_type}
                          >
                            <img
                              src="/assets/svg/doc.svg"
                              alt={`attachment-${index}`}
                              key={index}
                            />
                            <Typography>
                              <span>
                                {this.getFileNameFromUrl(attachment.url)}
                              </span>
                              .{this.getFileExtension(attachment.url)}
                            </Typography>
                          </a>
                        </>
                      );
                    } else if (attachment.type === "pdf") {
                      return (
                        <>
                          <a
                            href={attachment.url}
                            className={classes.attachment_type}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/assets/svg/pdf.svg"
                              alt={`attachment-${index}`}
                              key={index}
                            />
                            <Typography>
                              <span>
                                {this.getFileNameFromUrl(attachment.url)}
                              </span>
                              .{this.getFileExtension(attachment.url)}
                            </Typography>
                          </a>
                        </>
                      );
                    } else {
                      return (
                        <>
                          <a
                            href={attachment.url}
                            className={classes.img_container}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={attachment.url}
                              alt={`attachment-${index}`}
                              key={index}
                            />
                            <Typography>
                              <span>
                                {this.getFileNameFromUrl(attachment.url)}
                              </span>
                              .{this.getFileExtension(attachment.url)}
                            </Typography>
                          </a>
                        </>
                      );
                    }
                  }
                )}
            </Grid>
          </Grid>
        </Grid>
      </MyPATDialog>
    );
  }
}

//@ts-ignore
export default React.memo(withStyles(styles)(ViewChallengePopup));
